export default {
  props: {
    hideIfSinglePage: {
      type: Boolean,
      default: true,
    },
    range: {
      type: [Number, Boolean],
      default: 3, // set false to force all pages to be displayed
      validator: (value) => {
        return value === false || value % 2 === 1;
      },
    }
  },
  computed: {
    count() {
      if (this.$store.state.grid.meta.pagination) {
        return this.$store.state.grid.meta.pagination.count;
      }
      return 0;
    },
    current_page() {
      if(this.$store.state.grid.meta.pagination) {
        return this.$store.state.grid.meta.pagination.current_page;
      }
      return 0;
    },
    total_pages() {
      if(this.$store.state.grid.meta.pagination) {
        return this.$store.state.grid.meta.pagination.total_pages;
      }
      return 0;
    },
    pagesRange() {
      /**
       * @link: https://gist.github.com/kottenator/9d936eb3e4e3c3e02598
       */
      let delta = this.sidePages,
        left = this.current_page - delta,
        right = this.current_page + delta + 1,
        range = [],
        rangeWithDots = [],
        l;

      for (let i = 1; i <= this.total_pages; i++) {
        if (i === 1 || i === this.total_pages || i >= left && i < right) {
          range.push(i);
        }
      }

      for (let i of range) {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1);
          } else if (i - l !== 1) {
            rangeWithDots.push(null);
          }
        }
        rangeWithDots.push(i);
        l = i;
      }

      return rangeWithDots;
    },
    sidePages() {
      return (this.range - 1) / 2;
    },
  },
  methods: {
    setPage(n) {
      if (n >= 1 && n <= this.total_pages && n !== this.current_page) {
        this.$store.commit('grid/setPage', n);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/assets/js/theme-mixins/DataGridPaginator.js